import classNames from 'clsx';
import React from 'react';

import { getAvatarImage } from '../../../../utils/getAvatarImage';

import styles from './Avatar.scss';

interface AvatarProps {
  userName: string;
  size?: 'small' | 'large';
  avatar?: string;
}

const Avatar: React.FC<AvatarProps> = ({ size = 'large', userName, avatar }) => (
  <picture className={classNames(styles.avatarContainer, styles[size as keyof typeof styles])}>
    <img
      src={avatar ? `data:image/png;base64, ${avatar}` : getAvatarImage(userName)}
      alt={`${userName} avatar`}
    />
  </picture>
);

export default Avatar;
